module.exports = __webpack_public_path__ + "img/Magento_Logo.24f38401.svg";